import { SvgIcon, SvgIconProps } from '@mineral/core';
import React from 'react';

export const ProgressIcon: React.FC<SvgIconProps> =
  React.forwardRef<SVGSVGElement>((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM11.9913 5C8.1303 5 5 8.13452 5 12H6.58767C6.58767 9.01418 9.00601 6.59091 11.9911 6.59091C14.0436 6.59091 15.8272 7.74069 16.7385 9.43211L15.4378 9.43093C15.1093 9.43063 14.8427 9.69779 14.8425 10.027C14.8425 10.3561 15.1087 10.6229 15.4371 10.6229L15.4378 10.6229L17.7488 10.6205L18.9334 10.6188L18.9376 7.11639C18.938 6.7873 18.6721 6.5202 18.3436 6.5198L18.3429 6.5198C18.0142 6.5198 17.7477 6.78701 17.7477 7.11639L17.748 8.04016C16.4899 6.20424 14.3812 5 11.9913 5ZM12.0087 19C15.8697 19 19 15.8655 19 12H17.4123C17.4123 14.9858 14.994 17.4091 12.0089 17.4091C9.95635 17.4091 8.17278 16.2593 7.2615 14.5679L8.56217 14.5691C8.89069 14.5694 9.15725 14.3022 9.15755 13.973C9.15755 13.6439 8.89131 13.3771 8.56289 13.3771L8.56217 13.3771L6.25117 13.3795L5.06663 13.3812L5.06241 16.8836C5.06202 17.2127 5.32793 17.4798 5.65636 17.4802H5.65707C5.98579 17.4802 6.25226 17.213 6.25226 16.8836L6.25197 15.9598C7.51007 17.7958 9.61885 19 12.0087 19Z"
      />
    </SvgIcon>
  ));
